import { useEffect, useState } from "react";
import { ShoppingBag, MessageCircle } from "lucide-react";
import { SITE } from "../data/site";
import { useCart } from "../hooks/useCart";

const MobileStickyCTA = ({ onOpenCart }) => {
  const { count } = useCart();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ids = ["best-sellers", "collection"];
    const els = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (els.length === 0) return;

    const state = new Map(els.map((el) => [el.id, false]));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => state.set(e.target.id, e.isIntersecting));
        setVisible(Array.from(state.values()).some(Boolean));
      },
      { threshold: 0.05 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`lg:hidden fixed bottom-0 inset-x-0 z-30 px-3 pb-16 pt-2 pointer-events-none transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      aria-hidden={!visible}
    >
      <div className="pointer-events-auto bg-[hsl(var(--ink))] text-[hsl(var(--cream))] rounded-full shadow-[0_10px_40px_rgba(0,0,0,0.18)] flex items-center justify-between px-2.5 py-2 gap-2">
        <button
          data-testid="sticky-shop-collection"
          onClick={() => scrollTo("collection")}
          className="flex-1 text-sm py-2 pl-3 text-left"
        >
          Shop Collection
        </button>
        <button
          onClick={onOpenCart}
          data-testid="sticky-open-cart"
          aria-label="Open cart"
          className="relative w-10 h-10 rounded-full bg-[hsl(var(--cream))]/10 flex items-center justify-center"
        >
          <ShoppingBag className="w-4 h-4" />
          {count > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-[hsl(var(--clay))] text-[10px] text-[hsl(var(--ink))] flex items-center justify-center">
              {count}
            </span>
          )}
        </button>
        <a
          href={SITE.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-whatsapp"
          className="inline-flex items-center gap-1.5 bg-[hsl(var(--cream))] text-[hsl(var(--ink))] text-sm font-medium px-4 py-2 rounded-full"
        >
          <MessageCircle className="w-4 h-4" />
          WhatsApp
        </a>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
